import { DashboardApi20240730 } from '@sequencehq/api/dashboard/v20240730'
import {
  Text,
  IndigoIndigo60,
  Link,
  Primary13Regular,
  Primary14SemiBold,
  Table,
  Tbody,
  Td,
  Tr,
  Flex
} from '@sequencehq/core-components'
import { CustomerPreviewCardPill } from 'Customer/components/CustomerPreviewCard'

export const ProductPriceBillingSchedules = ({
  priceMetadata
}: {
  priceMetadata: DashboardApi20240730.Prices.PriceMetadata
}) => {
  return (
    <Flex
      flexDirection="column"
      gap="8px"
      flex={1}
      width="100%"
      maxWidth="480px"
    >
      <Text {...Primary14SemiBold}>Billing schedules</Text>

      <Table variant="v2" width="100%">
        <Tbody>
          {priceMetadata.billingSchedules.map(schedule => (
            <Tr
              key={schedule.billingScheduleId}
              sx={{
                _hover: {
                  cursor: 'default'
                }
              }}
            >
              <Td>
                <CustomerPreviewCardPill customerId={schedule.customerId} />
              </Td>
              <Td
                {...Primary13Regular}
                color={IndigoIndigo60}
                textAlign="right"
              >
                <Link.Unstyled
                  to={`/billing-schedules/${schedule.billingScheduleId}`}
                  style={{ fontWeight: '600' }}
                  data-testid={`pricingEditor.review.viewSchedule.${schedule.billingScheduleId}`}
                >
                  View schedule
                </Link.Unstyled>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Flex>
  )
}
